module.exports = __webpack_public_path__ + "img/tur.36c827e8.png";